<template>
  <Modal title="学员批量减课时" v-model="visible">
    <Form ref="BatchCourseChangeForm" class="form"
          :model="BatchCourseChangeParam"
          :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="学员ID" prop="uIds">
            <Input v-model="BatchCourseChangeParam.uIds" type="textarea" placeholder="id以 ; 拼接"></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="课程类型" prop="courseType">
            <Select v-model.number="BatchCourseChangeParam.courseType" :transfer="true">
              <Option v-for="item in courseTypeList" :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="减课时备注" prop="uIds">
            <Input v-model="BatchCourseChangeParam.memo" type="textarea" placeholder="减课时备注必填"></Input>
          </Form-item>
        </Col>

      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBatchCourseChange" @click="BatchCourseChange">确定
      </Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'BatchCourseChangeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    successCallback: {
      type: Function
    }
  },
  data() {
    return {
      courseTypeList: [
        {code: 1, text: '外教课'},
        {code: 2, text: '中教课'},
        {code: 8, text: '陪练课'}],
      visible: this.value,
      loadingBatchCourseChange: false,
      BatchCourseChangeParam: {
        uIds: '',
        courseType: 0,
        memo:''
      },
    }
  },
  methods: {
    BatchCourseChange() {
      let self = this

      self.loadingBatchCourseChange = true
      self.$http.post('/bookCourseChange/batch-add', this.BatchCourseChangeParam).then(function (res) {
        if (res && res.data === 0) {
          self.successCallback()
          self.visible = false
        }
        self.loadingBatchCourseChange = false
      }).catch(function (e) {
        self.visible = false
        self.loadingBatchCourseChange = false
      })
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      if (val === false) {
        this.BatchCourseChangeParam.uIds = ''
        this.BatchCourseChangeParam.courseType = 0
        this.BatchCourseChangeParam.memo = ''
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BatchCourseChangeModal.vue?1a1eb54c